import React from 'react';
import './EventDetails.css';
import AmbientStage from '../components/AmbientStage';
import BottomNav from '../components/BottomNav';
import RotatingDisc from '../components/RotatingDisc';
import fabricImg from '../assets/fabric.png';
import arrowIcon from '../assets/arrow.png';

const agenda = [
  { time: '06:15', label: 'Doors open' },
  { time: '06:30', label: 'Machine startup' },
  { time: '07:05', label: 'Q&A with engineers' },
];

function EventDetails({ activeScreen, onNavigate }) {
  return (
    <AmbientStage className="event-details-screen" image={fabricImg}>
      <header className="details-header">
        <button onClick={() => onNavigate('Home')} type="button">Back</button>
        <p className="eyebrow">Event Details</p>
      </header>

      <section className="details-hero" aria-label="Live machinery event details">
        <div className="details-copy">
          <span>Hall A / Machine Lane 04</span>
          <h1>Live Machinery Demonstrations</h1>
          <p>
            Watch textile automation, cutting systems, and finishing equipment
            run in real time with specialists explaining each production step.
          </p>
        </div>
        <RotatingDisc label="Starts" detail="6:30 PM" />
      </section>

      <section className="details-chips" aria-label="Event facts">
        <article>
          <span>Date</span>
          <strong>20 Apr</strong>
        </article>
        <article>
          <span>Zone</span>
          <strong>Hall A</strong>
        </article>
        <article>
          <span>Seats</span>
          <strong>48 left</strong>
        </article>
      </section>

      <section className="route-card" aria-label="Route to event">
        <div className="route-line" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <div>
          <p className="eyebrow">Fast Route</p>
          <h2>Enter west gate, turn right after textile rolls.</h2>
          <p>Estimated walk: 4 minutes from your current hall.</p>
        </div>
      </section>

      <section className="agenda-list" aria-label="Event agenda">
        <div className="details-section-title">
          <h3>Session Flow</h3>
          <span>Live</span>
        </div>
        {agenda.map((item) => (
          <article key={item.time}>
            <strong>{item.time}</strong>
            <p>{item.label}</p>
          </article>
        ))}
      </section>

      <button className="gold-action full details-cta" onClick={() => onNavigate('Ticket')} type="button">
        Save to my pass
        <img src={arrowIcon} alt="" aria-hidden="true" />
      </button>

      <BottomNav activeScreen={activeScreen} onNavigate={onNavigate} />
    </AmbientStage>
  );
}

export default EventDetails;
